module.exports = __webpack_public_path__ + "img/27_12.78d62439.png";